import React from "react";
import PropTypes from 'prop-types'
import {Provider} from "react-redux";
import routes from "../routes";
import {Router} from "react-router";

const Root = ({store, history}) => (
	<Provider store={store}>
		<Router history={history} routes={routes}/>
	</Provider>
)

Root.propTypes = {
	store: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired
}
export default Root


// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/containers/Root.prod.js